import React from 'react';
import { connect } from 'react-redux';

class Balance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [],
      openHistory: false,
    };
  }
  render() {
    const { balance } = this.props;
    console.log(balance);
    return (
      <iframe
        class="airtable-embed"
        src={`https://airtable.com/embed/${balance}?backgroundColor=grayLight&viewControls=on`}
        frameborder="0"
        onmousewheel=""
        width="100%"
        height="100%"
        // style="background: transparent; border: 1px solid #ccc;"
      ></iframe>
    );
  }
}

const mapStateToProps = (state) => ({
  balance: state.place.airtable.balance,
});

export default connect(mapStateToProps)(Balance);
